var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HAND",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #HAND .cls-1,\n      #HAND .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_341",
    "data-name": "Pfad 341",
    className: "cls-2",
    d: "M16,0A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14.172,14.172,0,0,1,16,30Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_943",
    "data-name": "Gruppe 943",
    transform: "translate(7.323 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_942",
    "data-name": "Gruppe 942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_342",
    "data-name": "Pfad 342",
    className: "cls-1",
    d: "M13.7,25a5.9,5.9,0,0,1-3.3-3.1A64.472,64.472,0,0,1,7.5,16a1.794,1.794,0,0,1,3.1-1.8c.4.7.8,1.3,1.2,2a.6.6,0,0,0,.1-.4v-6a1.722,1.722,0,0,1,1.6-1.9,1.8,1.8,0,0,1,1,.2.187.187,0,0,0,.3,0A1.82,1.82,0,0,1,16.1,7h.6A2.03,2.03,0,0,1,18,8.1c.1.2.2,0,.3,0a1.763,1.763,0,0,1,2.5,1.6v1.1a1.88,1.88,0,0,1,2.7,2,20.852,20.852,0,0,0,0,2.5,16.373,16.373,0,0,1-.7,5.4c-.6,2-1.5,3.7-3.8,4.2C17.1,25,15.4,25,13.7,25ZM12.6,13.3h0v3.2a2.2,2.2,0,0,1-.1.8.635.635,0,0,1-1.1.3A2.092,2.092,0,0,1,11,17a25.293,25.293,0,0,0-1.3-2.2.957.957,0,0,0-.9-.5.969.969,0,0,0-.7.8,1.268,1.268,0,0,0,.1.6c.9,1.7,1.7,3.5,2.6,5.2a8.847,8.847,0,0,0,1.8,2.5,2.173,2.173,0,0,0,1.9.7c1.1,0,2.2-.1,3.4,0a3.114,3.114,0,0,0,3-1.7,8.585,8.585,0,0,0,1.2-3.5,35.4,35.4,0,0,0,.3-6.5.9.9,0,1,0-1.8,0v3.8c0,.4-.2.6-.5.6s-.4-.3-.4-.6V9.7a.924.924,0,0,0-.6-1,.957.957,0,0,0-1.2,1v5.7a.43.43,0,0,1-.4.4c-.3,0-.4-.1-.5-.4V8.6a.908.908,0,0,0-.8-1,.817.817,0,0,0-.9.8V15c0,.3-.1.6-.4.6-.4,0-.5-.2-.5-.6V9.4a1,1,0,0,0-.6-1,.9.9,0,0,0-1.2.9C12.6,10.9,12.6,12.1,12.6,13.3Z",
    transform: "translate(-7.323 -7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.60737548d73b7c40334db87f03dd9425.svg";
export { ForwardRef as ReactComponent };